import { View } from "react-native";
import React from "react";
import { BillingInterval, SimplePlanPackageDetails } from "features/types";
import { getPlanType } from "utils/planPackageUtils";
import { MaterialCommunityIcons } from "@expo/vector-icons";
import { Text } from "@ui-kitten/components";
import { formatCurrency } from "utils/appUtils";

interface PlanNameWithPaymentIntervalProps {
  planPackage: SimplePlanPackageDetails;
  billingInterval: BillingInterval;
  monthlyPrice: string;
}
const PlanNameWithPaymentInterval: React.FC<
  PlanNameWithPaymentIntervalProps
> = ({ planPackage, billingInterval, monthlyPrice }) => {
  return (
    <View>
      <View
        style={{ flexDirection: "row", marginTop: 10, alignItems: "center" }}
      >
        <View style={{ marginRight: 5 }}>
          {getPlanType(planPackage) === "RESERVATION" ? (
            <MaterialCommunityIcons name="passport" size={32} color="black" />
          ) : (
            <MaterialCommunityIcons
              name="ticket-confirmation-outline"
              size={32}
              color="black"
            />
          )}
        </View>
        <View className="flex-shrink">
          <Text style={{ fontWeight: "700" }}>{planPackage.name}</Text>
          <Text>
            {billingInterval === "MONTHLY" ? (
              <Text>{formatCurrency(monthlyPrice)} / month</Text>
            ) : (
              <Text>Pay-In-Full</Text>
            )}
          </Text>
        </View>
      </View>
    </View>
  );
};

export default PlanNameWithPaymentInterval;
